export enum TabInfosActionTypes {
    ChangeTab = "CHANGE_TAB",
    SetCurrentTab = "SET_CURRENT_TAB",
}

export interface TabInfosAction {
    type: TabInfosActionTypes.ChangeTab | TabInfosActionTypes.SetCurrentTab;
    payload: {
        bindingPath: string;
        instance: string | undefined;
    };
}
